var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"screensaver",style:({ opacity: _vm.screensaverOpacity }),attrs:{"id":"screensaver"}},[_c('img',{ref:"logo",staticClass:"logo",style:({
      top: `${_vm.logoY}px`,
      left: `${_vm.logoX}px`,
      fill: _vm.logoColor,
      transition: `top ${_vm.verticalDuration}ms ease-in-out , left ${_vm.horizontalDuration}ms ease-in-out`
    }),attrs:{"src":require("../../assets/logo__24011701.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }